import { ENTER_KEY } from '../../../../constants';
import { classNames } from 'primereact/utils';

interface GoToPageProps {
  totalPages: number;
  goToPageValue: string;
  setGoToPageValue(value: string): void;
  handleGoToPage(value: string): void;
  titleClassName?: string;
  inputClassName?: string;
}

const GoToPage = ({
  totalPages,
  goToPageValue,
  setGoToPageValue,
  handleGoToPage,
  titleClassName,
  inputClassName,
}: GoToPageProps) => {
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setGoToPageValue(event.target.value);
  };

  const handleInputKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === ENTER_KEY) {
      handleGoToPage(event.currentTarget.value);
    }
  };

  const handleInputBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    handleGoToPage(event.target.value);
  };

  return (
    <div className="flex shrink-0 items-center gap-2">
      <span className={classNames('text-[0.75rem] whitespace-nowrap', titleClassName)}>Go to page</span>
      <input
        type="number"
        min="1"
        max={totalPages}
        aria-label="Go to page"
        value={goToPageValue}
        onChange={handleInputChange}
        onKeyDown={handleInputKeyDown}
        onBlur={handleInputBlur}
        className={classNames(
          'flex items-center',
          'w-15',
          'pt-[5px] pr-[28px] pb-[7px] pl-[12px]',
          'rounded-[4px]',
          'border-fletchers-gray-110 border',
          'bg-white',
          'text-[0.75rem] font-[400]',
          'outline-none focus:outline-none',
          'transition-colors duration-200',
          'focus:border-fletchers-green-300 focus:ring-fletchers-green-300 focus:ring-1',
          'hover:border-fletchers-gray-200',
          inputClassName,
        )}
      />
    </div>
  );
};

export default GoToPage;
